import axios from 'axios';
import Vue from 'vue';
import VueAxios from 'vue-axios';
import Fragment from 'vue-fragment';
import VueResizeObserver from 'vue-resize-observer';
import { bem } from 'vue-simple-bem';
import Confirmation from './components/Confirmation/Confirmation.vue';
import AllToggleCheckboxes from './components/Field/AllToggleCheckboxes/AllToggleCheckboxes.vue';
import CheckField from './components/Field/CheckField/CheckField.vue';
import ConsentField from './components/Field/ConsentField/ConsentField.vue';
import EmailField from './components/Field/EmailField/EmailField.vue';
import OptionsField from './components/Field/OptionsField/OptionsField.vue';
import PhoneField from './components/Field/PhoneField/PhoneField.vue';
import SelectField from './components/Field/SelectField/SelectField.vue';
import TextareaField from './components/Field/TextareaField/TextareaField.vue';
import TextField from './components/Field/TextField/TextField.vue';
import UploadField from './components/Field/UploadField/UploadField.vue';
import FieldGroup from './components/FieldGroup/FieldGroup.vue';
import HtmlLabel from './components/HtmlLabel/HtmlLabel.vue';
import Panel from './components/Panel/Panel.vue';
import Start from './components/Start/Start.vue';
import PersonalSummary from './components/Summary/PersonalSummary.vue';
import SummaryGroup from './components/Summary/SummaryGroup.vue';
import SummaryItem from './components/Summary/SummaryItem.vue';
import SummaryRow from './components/Summary/SummaryRow.vue';
import SummaryImage from './components/Summary/SummaryImage.vue';
import Wizard from './components/Wizard/Wizard.vue';
import WizardStep from './components/Wizard/WizardStep.vue';
import ImageSection from './components/ImageSection/ImageSection.vue';

Vue.directive('bem', bem);

Vue.use(Fragment.Plugin);
Vue.use(VueResizeObserver);
Vue.use(VueAxios, axios);

Vue.component('Wizard', Wizard);
Vue.component('WizardStep', WizardStep);
Vue.component('HtmlLabel', HtmlLabel);
Vue.component('Panel', Panel);
Vue.component('FieldGroup', FieldGroup);
Vue.component('EmailField', EmailField);
Vue.component('PhoneField', PhoneField);
Vue.component('TextareaField', TextareaField);
Vue.component('TextField', TextField);
Vue.component('SelectField', SelectField);
Vue.component('OptionsField', OptionsField);
Vue.component('CheckField', CheckField);
Vue.component('ConsentField', ConsentField);
Vue.component('UploadField', UploadField);
Vue.component('AllToggleCheckboxes', AllToggleCheckboxes);
Vue.component('SummaryItem', SummaryItem);
Vue.component('PersonalSummary', PersonalSummary);
Vue.component('SummaryRow', SummaryRow);
Vue.component('SummaryGroup', SummaryGroup);
Vue.component('SummaryImage', SummaryImage);
Vue.component('Confirmation', Confirmation);
Vue.component('Start', Start);
Vue.component('ImageSection', ImageSection);

// eslint-disable-next-line import/prefer-default-export
export const createWizard = ({
  el,
  name,
  template,
  initialData = {},
  additionalOptionSets = {},
  onSubmit = () => {},
  onStepChange = () => {},
  submitButtonLabel,
  nextButtonLabel,
  backButtonLabel,
}) => {
  if (el && name && template) {
    // eslint-disable-next-line no-new
    new Vue({
      ...template,
      el,
      name,
      provide: {
        wizardContext: {
          initialData,
          additionalOptionSets,
          onSubmit,
          onStepChange,
          submitButtonLabel,
          nextButtonLabel,
          backButtonLabel,
        },
      },
    });
  }
};
